package com.castly.admin.ui.components

import androidx.compose.runtime.*
import com.castly.admin.ui.theme.AppTheme
import com.castly.admin.ui.theme.BorderRadius
import com.castly.admin.ui.theme.Spacing
import com.castly.admin.ui.theme.Typography
import com.castly.admin.ui.theme.themeTransition
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun ConfirmDialog(
    isOpen: Boolean,
    title: String,
    message: String,
    confirmLabel: String = "Confirm",
    cancelLabel: String = "Cancel",
    isDanger: Boolean = true,
    onConfirm: () -> Unit,
    onCancel: () -> Unit
) {
    if (!isOpen) return

    val colors = AppTheme.colors

    // Overlay
    Div({
        onClick { onCancel() }
        style {
            property("position", "fixed")
            property("top", "0")
            property("left", "0")
            width(100.vw)
            height(100.vh)
            backgroundColor(Color("rgba(0, 0, 0, 0.5)"))
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            property("z-index", "2000")
        }
    }) {
        // Dialog
        Div({
            onClick { it.stopPropagation() }
            style {
                backgroundColor(Color(colors.surface))
                borderRadius(BorderRadius.lg)
                padding(Spacing.xxl)
                border(1.px, LineStyle.Solid, Color(colors.border))
                property("box-shadow", "0 10px 25px rgba(40,60,80,0.15)")
                maxWidth(420.px)
                width(90.percent)
                themeTransition()
            }
        }) {
            // Title
            H3({
                style {
                    margin(0.px)
                    marginBottom(Spacing.sm)
                    fontSize(Typography.lg)
                    color(Color(colors.text))
                }
            }) { Text(title) }

            // Message
            P({
                style {
                    margin(0.px)
                    marginBottom(Spacing.xl)
                    color(Color(colors.textMuted))
                    fontSize(Typography.base)
                    property("line-height", "1.5")
                }
            }) { Text(message) }

            // Buttons
            Div({
                style {
                    display(DisplayStyle.Flex)
                    justifyContent(JustifyContent.FlexEnd)
                    gap(Spacing.sm)
                }
            }) {
                // Cancel
                Button({
                    onClick { onCancel() }
                    style {
                        padding(Spacing.sm, Spacing.lg)
                        backgroundColor(Color(colors.surfaceHover))
                        color(Color(colors.text))
                        border(1.px, LineStyle.Solid, Color(colors.border))
                        borderRadius(BorderRadius.md)
                        cursor("pointer")
                        fontSize(Typography.sm)
                        fontWeight("500")
                    }
                }) { Text(cancelLabel) }

                // Confirm
                Button({
                    onClick { onConfirm() }
                    style {
                        padding(Spacing.sm, Spacing.lg)
                        backgroundColor(Color(if (isDanger) colors.danger else colors.primary))
                        color(Color("#ffffff"))
                        border(0.px)
                        borderRadius(BorderRadius.md)
                        cursor("pointer")
                        fontSize(Typography.sm)
                        fontWeight("500")
                    }
                }) { Text(confirmLabel) }
            }
        }
    }
}
